import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=0c8134e7&scoped=true&"
import script from "./notfound.vue?vue&type=script&lang=js&"
export * from "./notfound.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./notfound.vue?vue&type=style&index=0&id=0c8134e7&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "0c8134e7",
  "56b9a683"
  
)

export default component.exports